export default {"src":"https://cdn.seaya.az/dist//_next/static/media/content.f1e11907.svg","height":240,"width":320,"blurWidth":0,"blurHeight":0};